export default {
	_createSingleIframe() {
		if(this._exportIframeInstance) {
			return this._exportIframeInstance;
		}
		this._exportIframeInstance = document.createElement('iframe');
		document.body.appendChild(this._exportIframeInstance);

		return this._exportIframeInstance;
	},
	
	export(url) {
		this._createSingleIframe().src = url;
	}
}


// WEBPACK FOOTER //
// ./src/js/data.js